export default class Plant {

    code: string;
    desc: string;
    // bootstrap vue only sees value and text in their selectors
    value: string;
    text: string;

    constructor(){
        this.code = "";
        this.desc = "";
        this.value = "";
        this.text = "";
    }

}